// src/pages/SignUp.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './LandingPage.css';
import './Login.css';

export default function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Auth temporarily removed — accept any input and go to the dashboard.
    navigate('/dashboard');
  };

  const handleGoogleSignIn = () => {
    setError('');
    setMessage('');
    navigate('/dashboard');
  };

  return (
    <div className="container">
      <div className="background-overlay"></div>

      {/* Navbar */}
      <div className="navbar">
        <div className="logo-container">
          <Link to="/">
            <img src="/ob_logo_small_white.png" alt="OffsetBridge logo" className="logo-img" />
          </Link>
          <Link to="/" className="logo-text">OffsetBridge</Link>
        </div>
        <div className="nav-buttons">
          <button className="howItWorks-btn" onClick={() => navigate("/how-it-works")}>
            How It Works
          </button>
          <button className="login-btn" onClick={() => navigate("/login")}>
            Log In
          </button>
        </div>
      </div>

      {/* Sign Up form section */}
      <div className="hero">
        <img src="/logo.png" alt="OffsetBridge" className="hero-logo" />
        <h1 className="hero-title" style={{ fontSize: '48px', marginBottom: '16px' }}>
          Create Account
        </h1>
        <p className="hero-subtitle" style={{ marginBottom: '48px' }}>
          Sign up to start tracking your carbon offsets.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-container">
            <span className="input-icon email-icon">@</span>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="input-container">
            <span className="input-icon">🔒</span>
            <input
              type="password"
              placeholder="password (6+ chars)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="input-container">
            <span className="input-icon">🔒</span>
            <input
              type="password"
              placeholder="confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          {message && <p className="login-success">{message}</p>}
          <button type="submit" className="hero-cta">
            Sign Up
          </button>

          <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', color: '#fff' }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: 'rgba(255, 255, 255, 0.3)' }}></div>
            <span style={{ padding: '0 16px' }}>OR</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: 'rgba(255, 255, 255, 0.3)' }}></div>
          </div>

          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="hero-cta"
            style={{
              backgroundColor: '#fff',
              color: '#333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
              <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z" fill="#34A853"/>
              <path d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957C.347 6.175 0 7.55 0 9.002c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.426 0 9.003 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fill="#EA4335"/>
            </svg>
            Sign up with Google
          </button>

          <p style={{ marginTop: '20px', color: '#fff' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#4CAF50', textDecoration: 'underline' }}>
              Log in
            </Link>
          </p>
        </form>
      </div>

      {/* Footer */}
      <div className="footer">
        © 2025 OffsetBridge
        <Link to="/privacy-policy" className="privacy-link">
          Privacy Policy
        </Link>
        <Link to="/terms-and-conditions" className="terms-link">
          Terms & Conditions
        </Link>
      </div>
    </div>
  );
}
